/**
 * 语言切换器组件
 * 主入口，根据 variant 渲染不同形式的切换器
 */

import { ButtonGroup } from './ButtonGroup';
import { Dropdown } from './Dropdown';
import { Select } from './Select';
import { Minimal } from './Minimal';
import { LanguageDrawer } from './LanguageDrawer';
import type { LanguageSwitcherProps, SizeClasses } from './types';

// 尺寸样式映射
const sizeClasses: SizeClasses = {
  sm: 'text-xs px-2 py-1',
  md: 'text-sm px-3 py-1.5',
  lg: 'text-base px-4 py-2',
};

/**
 * 语言切换器主组件
 * @param variant - 展示形式：dropdown | buttons | select | minimal
 * @param size - 尺寸：sm | md | lg
 * @param className - 自定义样式类
 */
export function LanguageSwitcher({
  variant = 'dropdown',
  size = 'md',
  className = '',
}: LanguageSwitcherProps) {
  const commonProps = { sizeClasses, size, className };

  switch (variant) {
    case 'buttons':
      return <ButtonGroup {...commonProps} />;

    case 'select':
      return <Select {...commonProps} />;

    case 'minimal':
      return <Minimal {...commonProps} />;

    case 'dropdown':
    default:
      return <Dropdown {...commonProps} />;
  }
}

// 导出子组件和类型
export { ButtonGroup, Dropdown, Select, Minimal, LanguageDrawer };
export type { LanguageSwitcherProps };
